import styles from "./ErrorMessage.module.css";

export function ErrorMessage({ msg }: { msg: string }) {
   return <div className={styles["error-msg"]}>{msg}</div>;
}
